<template>
	<b-container class="pt-sm">
		<b-overlay :show="isLoading" no-wrap rounded="sm"></b-overlay>
		<div v-if="!isLoading && fileData && organizationData && fileData.isActive">
			<Card no-body shadow>
				<div align-v="center" slot="header">
					<div class="d-flex align-items-center justify-content-center">
						<b-img-lazy
							:src="organizationData.appLogo"
							:text="organizationData.appName"
							rounded="circle"
							class="avatar-xxl"
							style="border: 1px lightgray solid;"
						/>
					</div>
					<h2 v-if="false" class="mt-2 mb-0 text-center">
						{{ organizationData.appName }}
					</h2>
					<h5 v-if="false" class="text-center" style="color: gray;">
						To complete this document, please read and fill out all the required
						fields below and sign this document.
					</h5>
				</div>
				<b-container class="py-sm" ref="pdfElement">
					<h2 class="mb-0 text-center">{{ fileData.fileTitle }}</h2>
					<h4 v-if="fileData.fileSubTitle" class="text-center" style="color: gray;">
						{{ fileData.fileSubTitle }}
					</h4>
					<span class="mt-sm" v-html="fileData.fileDescription"> </span>

					<div v-if="isUserSignable">
						<hr />
						<form>
							<b-row>
								<b-col>
									<BaseInput
										v-model="userInput.firstName"
										label="First Name"
										placeholder="First Name"
										required
									></BaseInput>
								</b-col>
								<b-col>
									<BaseInput
										v-model="userInput.lastName"
										label="Last Name"
										placeholder="Last Name"
										required
									></BaseInput>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<BaseInput
										v-model="userInput.date"
										label="Date"
										type="date"
										required
										disabled
									></BaseInput>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<VueSignaturePad
										v-if="fileData.isSignable"
										ref="signaturePad"
										width="100%"
										height="280px"
										class="form-control"
									/>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<BaseCheckbox
										class="mt-2"
										@input="userInput.readDocument = !userInput.readDocument"
										:checked="userInput.readDocument"
										><h5>
											By signing this document and checking this box, you acknowledge and
											agree that you agree with all of this document's information
											knowingly and voluntarily.
										</h5></BaseCheckbox
									>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<h5
										v-if="errorMessage"
										class="my-2"
										style="text-align: center;color: red;"
									>
										{{ errorMessage }}
									</h5>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<div style="width: 100%;text-align: end;" class="mt-2">
										<BaseButton
											v-if="fileData.isSignable"
											outline
											size="sm"
											@click="clearSignature"
											>Clear</BaseButton
										>
										<BaseButton size="sm" @click="submitFile">Submit</BaseButton>
									</div>
								</b-col>
							</b-row>
						</form>
					</div>
				</b-container>
			</Card>
			<a target="_blank" :href="DominionInformation.dominionWebsite">
				<b-row class="my-sm align-items-center" style="opacity: 0.4;">
					<b-col class="p-0 align-items-center">
						<h6
							class="mb-0"
							style="text-align: right;color: black;font-weight: bold;"
						>
							POWERED BY
						</h6>
					</b-col>
					<b-col class="p-0">
						<b-img fluid left :src="logo" style="height: 20px;" />
					</b-col>
				</b-row>
			</a>
		</div>
		<div v-else-if="!isLoading">
			<b-container>
				<div class="header-body text-center my-lg py-lg">
					<b-row class="justify-content-center align-items-center">
						<b-col xl="5" lg="6" md="6" class="px-5">
							<h1 class="">Ooops!</h1>
							<p class="text-lead ">
								This document is not found. Please make sure you are looking for the
								correct document.
							</p>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<BaseButton
								tag="a"
								target="_blank"
								:href="DominionInformation.dominionWebsite"
								>Visit Dominion Studio</BaseButton
							>
						</b-col>
					</b-row>
				</div>
			</b-container>
		</div>
	</b-container>
</template>
<script>
import {
	collection,
	doc,
	getDoc,
	getDocs,
	query,
	setDoc,
	where,
} from '@firebase/firestore';
import { mapActions } from 'vuex';
import {
	getOrganizationFirestore,
	getOrganizationStorage,
} from '../../resources/orgFirebase';
import { VueSignaturePad } from 'vue-signature-pad';
import html2pdf from 'html2pdf.js';
import logo from 'logo/LogoHorizontal_Dark.png';
import Card from '../../components/Card.vue';
import DominionInformation from '../../resources/DominionInformation';
import BaseButton from '../../components/BaseButton.vue';
import BaseInput from '../../components/BaseInput.vue';
import { getDownloadURL, ref, uploadBytes } from '@firebase/storage';
import { GeneralPaths } from '../../routes/routesNames';
import BaseCheckbox from '../../components/BaseCheckbox.vue';
import FileItemManager from '../../helpers/FileItemManager';

export default {
	props: {
		orgId: {
			type: String,
			default: null,
		},
		userId: {
			type: String,
			default: null,
		},
		fileId: {
			type: String,
			default: null,
		},
		title: {
			type: String,
			default: 'Files',
		},
	},
	metaInfo() {
		return {
			title: this.title,
		};
	},
	data() {
		return {
			logo,
			DominionInformation,
			isLoading: true,
			organizationData: null,
			orgData: null,
			fileData: null,
			errorMessage: null,
			isUserSignable: false,
			userInput: {
				firstName: null,
				lastName: null,
				date: null,
				readDocument: false,
			},
			tableHeaders: [
				{
					key: 'description',
					label: 'Description',
					sortable: false,
				},
				{
					key: 'amount',
					label: 'Amount',
					sortable: false,
				},
			],
			tableData: [],
		};
	},
	methods: {
		...mapActions(['getOrganization']),
		getOrgInformation() {
			this.getOrganization({ orgId: this.orgId })
				.then((orgData) => {
					this.orgData = orgData;
					this.getFileData();
				})
				.catch((error) => {
					this.isLoading = false;
					this.fileData = 'No Document Found1';
					console.log('No Document Found1');
					console.log(error.message);
				});
		},
		getFileData() {
			const firestore = getOrganizationFirestore(this.orgData);
			const fileRef = doc(firestore, `files/${this.fileId}`);
			const publicInfoRef = doc(firestore, 'account/publicInformation');
			getDoc(fileRef).then((snapshot) => {
				if (snapshot.exists()) {
					getDoc(publicInfoRef)
						.then((orgSnap) => {
							if (orgSnap.exists()) {
								this.isLoading = false;
								this.organizationData = orgSnap.data();
								this.fileData = snapshot.data();
								this.title = `${this.fileData.fileTitle} - ${this.organizationData.appName}`;
								this.getUserSignedData();
							} else {
								this.isLoading = false;
							}
						})
						.catch((error) => {
							this.isLoading = false;
							console.log(error.message);
						});
				} else {
					this.isLoading = false;
					this.fileData = 'No Document Found1';
					console.log('No Document Found1');
				}
			});
		},
		getUserSignedData() {
			if (this.userId) {
				const firestore = getOrganizationFirestore(this.orgData);
				const usersFileRef = collection(firestore, `users/${this.userId}/files`);
				const userQueryInfo = query(
					usersFileRef,
					where('fileId', '==', this.fileId)
				);
				getDocs(userQueryInfo).then((userDocSnapshot) => {
					if (!userDocSnapshot.empty) {
						//user signed this doc
						const signedData = userDocSnapshot.docs[0].data();
						this.pushToSignedView(signedData.fileDocumentURL);
					} else {
						//user didnt sign // update information
						this.isUserSignable = true;
					}
				});
			}
		},
		clearSignature() {
			this.$refs.signaturePad.undoSignature();
		},
		submitFile() {
			const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
			if (this.$helpers.isBlank(this.userInput.firstName)) {
				this.errorMessage =
					'Please complete all necessary fields for this document.';
				return;
			} else if (this.$helpers.isBlank(this.userInput.lastName)) {
				this.errorMessage =
					'Please complete all necessary fields for this document.';
				return;
			} else if (isEmpty) {
				this.errorMessage =
					'Please complete all necessary fields for this document.';
				return;
			} else if (!this.userInput.readDocument) {
				this.errorMessage = 'Please ackowledge that you have read this document.';
				return;
			} else {
				this.errorMessage = null;
				setTimeout(() => {
					this.saveSignedFile();
				}, 500);
			}
		},
		saveSignedFile() {
			this.isLoading = true;
			var options = {
				margin: 0,
				filename: this.fileData.fileTitle,
				image: { type: 'png', quality: 1 },
				html2canvas: { scale: 2 },
				jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
			};
			html2pdf()
				.set(options)
				.from(this.$refs.pdfElement)
				.outputPdf('blob')
				.then((result) => {
					FileItemManager.signUserDocument(
						this.orgData,
						this.userId,
						this.fileId,
						this.fileData,
						result
					)
						.then((downloadURL) => {
							this.pushToSignedView(downloadURL);
						})
						.catch((errorMessage) => {
							this.isLoading = false;
							this.errorMessage = errorMessage;
							console.log(`Error3: ${errorMessage}`);
						});
				});
		},
		pushToSignedView(documentLink) {
			this.$router.push({
				name: GeneralPaths.signedView.name,
				query: {
					userId: this.userId,
				},
				params: {
					documentLink: documentLink,
					orgData: this.orgData,
					organizationData: this.organizationData,
					fileData: this.fileData,
				},
			});
		},
	},
	mounted() {
		this.getOrgInformation();
		this.userInput.date = this.$helpers.formatDate(new Date(), 'yyyy-MM-dd');
	},
	components: { Card, BaseButton, BaseInput, VueSignaturePad, BaseCheckbox },
};
</script>
